var digistormWeb = {
  init: function () {
    // helper for iOS issues
    this.iOS =
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

    // load nav
    this.nav();

    // load tabs
    this.tabs();
    this.accordions();

    // load videos
    this.videos.init();

    // load carousel
    this.slick();

    // load calendars
    this.calendars();
    this.events();
    this.eventsNewsletter();
    this.eventsNewsletterMobile();

    this.forms();
    this.gdprBanner();
    this.popups();
    this.analytics();

    this.employment();

    this.newsletters();

    this.social();

    this.page_menu_widget();
    this.video_modal();
    this.read_more();
    this.tags();

    this.buttonTouch();

    this.zoomIframe();
    this.iframefix();
    this.news();
  },

  iframefix: function () {
    $('.html-block.default-video-block iframe').each(function(i,el) {
        $(this).css('height', $(el).attr('height'))
    })
  },
  zoomIframe: function () {
    $('.embed-container iframe').each(function () {
      var _this = $(this);
      $(this).closest('.embed-container').addClass('zoom');
    });
  },

  nav: function () {
    // find any navbar burger buttons
    $('.navigation')
      .find('.navbar-burger')
      .click(function (e) {
        e.preventDefault();

        // find specified navbar
        target = $(this).attr('data-target');

        if (target.length) {
          // toggle active class on burger button
          $(this).toggleClass('is-active');

          // toggle active class on specified menu
          $('#' + target).toggleClass('is-active');
        }
      });

    // find any navbar search buttons
    $('.navigation')
      .find('.search-button')
      .click(function (e) {
        e.preventDefault();

        // find specified navbar
        target = $(this).attr('data-target');

        if (target.length) {
          // toggle active class on specified element
          $('#' + target).toggleClass('is-active');

          if ($('#' + target).is('.is-active')) {
            $('input.search').focus();
          } else {
            $('input.search').blur();
          }
        }
      });
  },

  videos: {
    init: function () {
      var _self = this;

      // check if there is a video player wrapper
      if ($('.video-player').length) {
        $('.video-player').each(function () {
          _self.loadVideo(this);
        });
      }

      _self.controls();
      _self.carousel();
    },

    controls: function () {
      // initialise video controls

      $('.video-carousel .banner .control-pause').click(function () {
        $player = $(this).closest('.banner').find('.video-player');
        switch (digistormWeb.videos.togglePlay($player)) {
          case 'no-data':
            break;
          case true:
            $(this).removeClass('fa-play').addClass('fa-pause');
            break;
          case false:
            $(this).removeClass('fa-pause').addClass('fa-play');
            break;
        }
      });

      $('.video-carousel .banner .control-vol').click(function () {
        $player = $(this).closest('.banner').find('.video-player');
        switch (digistormWeb.videos.toggleMute($player)) {
          case 'no-data':
            break;
          case true:
            $(this).removeClass('fa-volume-off').addClass('fa-volume-up');
            break;
          case false:
            $(this).removeClass('fa-volume-up').addClass('fa-volume-off');
            break;
        }
      });
    },

    carousel: function () {
      // handle videos inside slick carousels
      $('.video-carousel')
        .on('init', function (event, slick) {
          // mark carousel as initialized
          slick.is_initialized = true;
        })
        .on('setPosition', function (event, slick) {
          // synchronize slides with videos

          if (slick.is_initialized) {
            // the slide up next
            var $newSlide = $(slick.$slides[slick.currentSlide]);

            // pause others
            $newSlide
              .closest('.video-carousel')
              .find('.banner')
              .not($newSlide)
              .find('.video-player')
              .each(function (i, e) {
                if (digistormWeb.iOS) {
                  // currently there's a bug with plyr where pause won't work on iOS
                  digistormWeb.videos.stopVideo($(e));
                } else {
                  digistormWeb.videos.pauseVideo($(e));
                }
              });

            // play new slide
            var video = $newSlide.find('.video-player');
            digistormWeb.videos.playVideo(video);
            if (video.data() && video.data().player) {
              // This slide is a video, pause slick autoslide
              slick.$slider.slick('slickPause');
            } else {
              // This slide is not a video, resume slick autoslide
              slick.$slider.slick('slickPlay');
              $('.circleProgress').css('animation-duration', 5.9 + 's');
            }
          }
        });
    },

    loadVideo: function (el) {
      // load a video element

      // get each config attr from this element
      var settings = JSON.parse($(el).attr('data-settings'));

      // grab player elements
      var player = $(el).find('.player');

      var plyr = new Plyr(player[0], settings);
      // set up each video
      $(el).data({
        player: plyr,
      });

      // if a carousel video, go to the next slide on video end
      var $carousel = $(el).closest('.video-carousel');
      if ($carousel.length) {
        if (plyr.source && plyr.source.indexOf('youtube') >= 0) {
          // youtube loop doesn't work, manually detect end of video
          plyr.on('timeupdate', function (event) {
            if (plyr.currentTime >= plyr.duration - 0.1) {
              plyr.restart();
              if ($carousel.find('.banner').length > 1) {
                $carousel.slick('slickNext');
              }
            }
          });
        } else {
          // on loop, go to the next slide
          plyr.on('seeked', function (event) {
            $carousel.slick('slickNext');
          });
        }

        plyr.on('playing', function () {
          $(el)
            .closest('.banner')
            .find('.control-pause')
            .removeClass('fa-play')
            .addClass('fa-pause');
        });
        plyr.on('pause', function () {
          $(el)
            .closest('.banner')
            .find('.control-pause')
            .removeClass('fa-play')
            .addClass('fa-pause');
        });
      }

      if (settings.muted && settings.autoplay) {
        digistormWeb.videos.attemptPlay(plyr);
      }
    },

    attemptPlay: function (player, count) {
      // attempts to play the video multiple times in case element is still loading

      if (!Number.isInteger(count)) {
        count = 0;
      }

      player.volume = 0;
      player.muted = true;
      player.play();
      if (count < 15) {
        setTimeout(function () {
          if (!player.playing) {
            count++;
            digistormWeb.videos.attemptPlay(player, count);
          }
        }, 1000);
      }
    },

    playVideo: function ($el) {
      if ($el.data() && $el.data().player) {
        $el.data().player.play();
      }
    },
    pauseVideo: function ($el) {
      if ($el.data() && $el.data().player) {
        $el.data().player.pause();
      }
    },
    stopVideo: function ($el) {
      if ($el.data() && $el.data().player) {
        $el.data().player.stop();
      }
    },
    togglePlay: function ($el) {
      if ($el.data() && $el.data().player) {
        $el.data().player.togglePlay();
        return $el.data().player.playing;
      }
      return 'no-data';
    },
    toggleMute: function ($el) {
      if ($el.data() && $el.data().player) {
        player = $el.data().player;
        if (player.volume == 0) {
          player.volume = 1;
          return true;
        } else {
          player.volume = 0;
          return false;
        }
      }
      return 'no-data';
    },
  },

  slick: function () {
    // initialise banners
    $('.banners').slick({
      arrows: false,
    });

    var time = 2;
    var $bar, $slick, isPause, tick, percentTime;

    $slick = $('.intro-wrap .group-slick');
    $slick.slick({
      draggable: true,
      pauseOnDotsHover: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      autoplay: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 600,
          settings: 'unslick',
        },
      ],
    });

    $bar = $('.intro-wrap .progress');

    $('.slider-wrapper').on({
      mouseenter: function () {
        isPause = true;
      },
      mouseleave: function () {
        isPause = false;
      },
    });

    function startProgressbar() {
      resetProgressbar();
      percentTime = 0;
      isPause = false;
      tick = setInterval(interval, 10);
    }

    function interval() {
      if (isPause === false) {
        percentTime += 1 / (time + 0.1);
        $bar.css({
          width: percentTime + '%',
        });
        if (percentTime >= 100) {
          $slick.slick('slickNext');
          startProgressbar();
        }
      }
    }

    function resetProgressbar() {
      $bar.css({
        width: 0 + '%',
      });
      clearTimeout(tick);
    }

    startProgressbar();

    // load basic slick on all basic slicks
    $('.slider-box').slickLightbox({
      itemSelector: '.item .image-box > a',
      caption: 'caption',
    });

    // load basic slick on all full galleries
    $('.gallery.is-full').find('.slick').slick();

    // lightbox config
    $('.gallery-wrap').find('ul').slickLightbox({
      itemSelector: '> li > a',
      caption: 'caption',
    });

    $('.gallery-wrap .more-s').click(function (e) {
      e.preventDefault();
      $(this).closest('.gallery-wrap').find('.is-hidden:first a').click();
    });
  },

  buttonTouch: function () {
    var clickDelay = null;
    var event = null;
    var element = null;

    var window_width = $(window).width();

    $('.slider-bar li').on('touchstart', function (e) {
      if (window_width < 800) {
        $(this).addClass('touch');
        if (!$(this).hasClass('expanded')) {
          e.preventDefault();
          $(this).removeClass('expanded');
        }
        $('.slider-bar li').removeClass('expanded');
        $(this).addClass('expanded');
      }
    });
    $(window).scroll(function () {
      $('.slider-bar li').removeClass('expanded');
    });
  },

  tabs: function () {
    var _self = this;

    // transform tabs into work of magic
    $('.tabs')
      .find('.tab-title')
      .click(function () {
        // get the relative tabs
        var $tabs = $(this).closest('.tabs');
        var activeIndex = $(this).index();

        // remove active class from all tabs
        $tabs.find('.tab-title').removeClass('is-active');
        $tabs.find('.tab-content').removeClass('is-active');

        // add active to current tab
        $(this).addClass('is-active');
        $tabs.find('.tab-content').eq(activeIndex).addClass('is-active');
      });
  },

  accordions: function () {
    // accordions
    $('.tabs.style-accordion').each(function () {
      var $group = $(this);

      $('.accordion-wrapper .accordion-header', $group).click(function () {
        var $wrapper = $(this).closest('.accordion-wrapper');
        var wasActive = $wrapper.hasClass('is-active');

        // close the accordions
        $group.find('.accordion-wrapper').removeClass('is-active');
        $group.find('.accordion-content').css({ 'max-height': 0 });

        // if the accordion was active then lets just close it
        if (wasActive) {
          return true;
        }

        // get relative height needed to show the content
        var height = $wrapper.find('.tab-content').outerHeight();

        // open the accordion
        $wrapper.addClass('is-active');
        $wrapper
          .find('.accordion-content')
          .css({ 'max-height': height + 'px' });
      });
    });
  },

  tags: function () {
    function getParameterByName(name, url) {
      var values = [];
      if (!url) url = location.href;

      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');

      var pattern = name + '=([^&#]+)';
      var o_reg = new RegExp(pattern, 'ig');
      while (true) {
        var matches = o_reg.exec(url);
        if (matches && matches[1]) {
          values.push(matches[1]);
        } else {
          break;
        }
      }

      if (!values.length) {
        return null;
      } else {
        return values;
      }
    }

    $.ajax({
      url: 'https://eduapp.com.au/api/v3/tags.jsonp?api_token=337ce9171a80eaccb6a1b911b4c43608dbbb2855',
      dataType: 'jsonp',
      type: 'GET',
      success: function (response) {
        $.each(response, function (index, tag_group) {
          $('#calendar-category-select').append(
            $('<option>').attr('value', tag_group.id).text(tag_group.name)
          );
        });

        var tag_id = getParameterByName('category');
        tag_id ? $('#calendar-category-select').val(tag_id) : '';
        if (tag_id) {
          var tag_name = $('.calendar-category-select')
            .find('option[value="' + tag_id + '"]')
            .html();
          $('.tag-name').html(tag_name + ' Calendar');
        }
      },
      error: function (err) {
        console.log(err);
      },
    });
  },

  calendars: function () {
    var _self = this;

    const urlParams = new URLSearchParams(window.location.search);
    const categorySelected = urlParams.get('category');

    $('#calendar-category-select').change(function () {
      var value = $(this).val();
      value = '?category=' + value;
      document.location = value;
    });

    $('[data-calendars]').each(function () {
      var calendarUrl = $(this).attr('data-calendar-url');

      if (categorySelected) {
        calendarUrl = calendarUrl + '&tag_ids[]=' + categorySelected;
        console.log(calendarUrl);
      }

      var calendarTimezone = $(this).attr('data-calendar-timezone');

      $('.calendar-desktop').fullCalendar({
        events: function (start, end, calendarTimezone, callback) {
          var url =
            calendarUrl + '&start=' + start.unix() + '&end=' + end.unix();
          $('.calendar-desktop-loading-indicator').addClass('show');
          $.ajax({ url: url }).done(function (response) {
            $('.calendar-desktop-loading-indicator').removeClass('show');
            callback(response);
          });
        },
        eventDataTransform: function (e) {
          e.start = moment
            .tz(parseInt(e.start_time) * 1000, calendarTimezone)
            .format();

          if (e.end_time != null) {
            e.end = moment
              .tz(parseInt(e.end_time) * 1000, calendarTimezone)
              .format();
          }
          e.allDay = e.all_day;
          if (e.tags) {
            e.tags.forEach(function (tag) {
              e.color = tag.color;
            });
          }
          e.url = '';
          return e;
        },
        editable: false,
        timeFormat: 'h:mm A',
        eventClick: function (event, jsEvent, view) {
          var $target = $(jsEvent.target);
          var $event = $target.closest('.fc-event-container');
          var $modal = $event.find('.cal-modal');

          if (!$target.closest('.cal-modal').length) {
            // if not clicking the modal
            if (!$modal.length) {
              // add the modal if it doesn't exist

              $modal = _self.createEventModal(event, calendarTimezone);
              $event.append($modal);

              setTimeout(function () {
                $modal.addClass('active');
              }, 100);
            } else {
              $modal.addClass('active');
            }
          }
        },
      });

      $('.calendar-mobile').digistormMobileCalendar({
        url: calendarUrl,
        timezone: calendarTimezone,
      });
    });
  },

  events: function () {
    var _self = this;
    $('[data-events-load]').each(function () {
      var calendarUrl = $(this).attr('data-calendar-url');
      var calendarTimezone = $(this).attr('data-calendar-timezone');

      var block = $('.events-wrapper', this);
      var limit = 6;

      $.ajax({
        url: calendarUrl,
        data: {
          start: Math.floor(Date.now() / 1000),
          limit: limit,
        },
        dataType: 'json',
        success: function (events) {
          var eventsClone = $(
            '<div class="event"><div class="event-date"><div class="event-date"></div></div><div class="event-details"><h3 class="event-title"></h3><small class="event-time"></small></div></div>'
          );

          events.sort(function (x, y) {
            return x.start_time - y.start_time;
          });

          $.each(events, function (index, event) {
            // stop loop
            if (index >= limit) {
              return false;
            }

            var newClone = eventsClone.clone(true);
            var mStart = moment.tz(
              parseInt(event.start_time) * 1000,
              calendarTimezone
            );
            var mEnd = moment.tz(
              parseInt(event.end_time) * 1000,
              calendarTimezone
            );

            newClone.find('.event-date').text(mStart.format('D MMMM'));

            if (event.allDay) {
              newClone.find('.event-time').text('all day event');
            } else {
              if (event.start_time == event.end_time) {
                newClone.find('.event-time').text(mStart.format('h:mm a'));
              } else {
                newClone
                  .find('.event-time')
                  .text(
                    mStart.format('h:mm a') + ' - ' + mEnd.format('h:mm a')
                  );
              }
            }

            newClone.find('.event-title').text(event.title);
            block.append(newClone);

            newClone.click(function () {
              var modal = newClone.data('modal');
              if (!modal) {
                modal = _self
                  .createEventModal(event)
                  .appendTo($('body'), calendarTimezone);
                newClone.data('modal', modal);
              }

              setTimeout(function () {
                modal.addClass('active');
              }, 100);
            });
          });

          $('.event-block', block).each(function () {
            $(this).addClass('blocks-' + $(this).find('.event').length);
            $(this)
              .find('.event')
              .wrapAll('<div class="events-block-inside"></div>');
          });
        },
      })
        .fail(function () {
          block.html('<p class="error"><strong>Unknown error</strong></p>');
        })
        .always(function () {
          block.addClass('events-loaded');
        });
    });
  },

  eventsNewsletter: function () {
    var _self = this;
    $('[data-newsletter-load]').each(function () {
      var calendarUrl = $(this).attr('data-calendar-url');
      var calendarTimezone = $(this).attr('data-calendar-timezone');

      var block = $('.events-wrapper', this);
      var limit = 5;

      $.ajax({
        url: calendarUrl,
        data: {
          start: Math.floor(Date.now() / 1000),
          end: Math.floor(Date.now() / 1000) + 60 * 60 * 24 * 365,
        },
        dataType: 'json',
        success: function (events) {
          var eventsClone = $('.newsletter-events-template');

          $.each(events, function (index, event) {
            // stop loop
            if (index >= limit) {
              return false;
            }

            var newClone = eventsClone.clone(true);
            newClone.removeClass('newsletter-events-template');
            var mStart = moment.tz(
              parseInt(event.start_time) * 1000,
              calendarTimezone
            );
            var mEnd = moment.tz(
              parseInt(event.end_time) * 1000,
              calendarTimezone
            );

            newClone.find('.event-date').text(mStart.format('D'));
            newClone.find('.event-month').text(mStart.format('MMM'));

            if (event.allDay) {
              newClone.find('.event-time').text('all day event');
            } else {
              if (event.start_time == event.end_time) {
                newClone.find('.event-time').html(mStart.format('h:mm a'));
              } else {
                newClone
                  .find('.event-time')
                  .html(
                    mStart.format('h:mm a') + ' TO ' + mEnd.format('h:mm a')
                  );
              }
            }

            newClone.find('.event-title').text(event.title);
            block.append(newClone);

            newClone.click(function () {
              var modal = newClone.data('modal');
              if (!modal) {
                modal = _self
                  .createEventModal(event)
                  .appendTo($('body'), calendarTimezone);
                newClone.data('modal', modal);
              }

              setTimeout(function () {
                modal.addClass('active');
              }, 100);
            });
          });

          $('.event-block', block).each(function () {
            $(this).addClass('blocks-' + $(this).find('.event').length);
            $(this)
              .find('.event')
              .wrapAll('<div class="events-block-inside"></div>');
          });
        },
      })
        .fail(function () {
          block.html('<p class="error"><strong>Unknown error</strong></p>');
        })
        .always(function () {
          block.addClass('events-loaded');
        });
    });
  },
  eventsNewsletterMobile: function () {
    var _self = this;
    $('[data-newsletter-load-mobile]').each(function () {
      var calendarUrl = $(this).attr('data-calendar-url');
      var calendarTimezone = $(this).attr('data-calendar-timezone');

      var block = $('.events-wrapper', this);
      var limit = 5;

      $.ajax({
        url: calendarUrl,
        data: {
          start: Math.floor(Date.now() / 1000),
          end: Math.floor(Date.now() / 1000) + 60 * 60 * 24 * 365,
        },
        dataType: 'json',
        success: function (events) {
          var eventsClone = $('.newsletter-events-template-mobile');

          $.each(events, function (index, event) {
            // stop loop
            if (index >= limit) {
              return false;
            }

            var newClone = eventsClone.clone(true);
            newClone.removeClass('newsletter-events-template');
            var mStart = moment.tz(
              parseInt(event.start_time) * 1000,
              calendarTimezone
            );
            var mEnd = moment.tz(
              parseInt(event.end_time) * 1000,
              calendarTimezone
            );

            newClone.find('.event-date').text(mStart.format('D'));
            newClone.find('.event-month').text(mStart.format('MMM'));

            if (event.allDay) {
              newClone.find('.event-time').text('all day event');
            } else {
              if (event.start_time == event.end_time) {
                newClone.find('.event-time').html(mStart.format('h:mm a'));
              } else {
                newClone
                  .find('.event-time')
                  .html(
                    mStart.format('h:mm a') + ' TO ' + mEnd.format('h:mm a')
                  );
              }
            }

            newClone.find('.event-title').text(event.title);
            block.append(newClone);

            newClone.click(function () {
              var modal = newClone.data('modal');
              if (!modal) {
                modal = _self
                  .createEventModal(event)
                  .appendTo($('body'), calendarTimezone);
                newClone.data('modal', modal);
              }

              setTimeout(function () {
                modal.addClass('active');
              }, 100);
            });
          });

          $('.event-block', block).each(function () {
            $(this).addClass('blocks-' + $(this).find('.event').length);
            $(this)
              .find('.event')
              .wrapAll('<div class="events-block-inside"></div>');
          });
        },
      })
        .fail(function () {
          block.html('<p class="error"><strong>Unknown error</strong></p>');
        })
        .always(function () {
          block.addClass('events-loaded');
        });
    });
  },

  // create modal from reach event
  createEventModal: function (event, calendarTimezone) {
    $modal = $('<div class="cal-modal"></div>');
    var $holder = $('<div class="content-holder"></div>');
    var $content = $('<div class="content"></div>');

    $content.append('<h2>' + event.title + '</h2>');

    if (typeof calendarTimezone == 'undefined') {
      calendarTimezone = event.timezone;
    }

    var mStart = moment.tz(parseInt(event.start_time) * 1000, calendarTimezone);
    var mEnd = moment.tz(parseInt(event.end_time) * 1000, calendarTimezone);

    if (mStart.isSame(mEnd, 'day')) {
      if (event.allDay) {
        $content.append(
          '<small>' + mStart.format('D MMMM') + ' (All Day)</small>'
        );
      } else {
        $content.append(
          '<small>' +
            mStart.format('D MMMM') +
            ' (' +
            mStart.format('h:mma') +
            ' - ' +
            mEnd.format('h:mma') +
            ')</small>'
        );
      }
    } else {
      $content.append(
        '<small>' +
          mStart.format('D MMM') +
          ' - ' +
          mEnd.format('D MMM') +
          '</small>'
      );
    }
    $content.append('<p>' + event.body + '</p>');

    if (event.attachments && event.attachments.length) {
      $.each(event.attachments, function (i, attachment) {
        switch (attachment.type) {
          case 'address':
            $content.append(
              '<div class="attachment attachment-address"><i class="fa fa-map-marker"></i> ' +
                String(attachment.address).replace('\n', '<br>') +
                '</div>'
            );
            break;
          case 'contact':
            var contact_details = [];
            if (attachment.contact_name) {
              contact_details.push(attachment.contact_name);
            }
            if (attachment.contact_phone) {
              contact_details.push(
                $('<a>')
                  .attr('href', 'tel:' + attachment.contact_phone)
                  .text(attachment.contact_phone)
                  .prop('outerHTML')
              );
            }
            if (attachment.contact_email) {
              contact_details.push(
                $('<a>')
                  .attr('href', 'mailto:' + attachment.contact_email)
                  .text(attachment.contact_email)
                  .prop('outerHTML')
              );
            }
            $content.append(
              '<div class="attachment attachment-contact"><i class="fa fa-phone"></i> ' +
                contact_details.join('<br>') +
                '</div>'
            );
            break;
          case 'link':
            $content.append(
              '<div class="attachment attachment-link"><i class="fa fa-link"></i> ' +
                $('<a target="blank">')
                  .attr('href', attachment.url)
                  .text(attachment.url)
                  .prop('outerHTML') +
                '</div>'
            );
            break;
          case 'file':
            $content.append(
              '<div class="attachment attachment-file"><i class="fa fa-file"></i> ' +
                $('<a target="blank">')
                  .attr('href', attachment.url)
                  .text(attachment.file_name)
                  .prop('outerHTML') +
                '</a></div>'
            );
            break;
        }
      });
    }

    $content.append(
      '<a class="dsmcal-addtocalendar" href="' +
        generateIcs(event) +
        '" download="' +
        event.title +
        '.ics"><svg class="dsmcal-cal-icon" viewBox="0 0 10 11" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M9.5,1.5 L9,1.5 L9,0.5 L8,0.5 L8,1.5 L4,1.5 L4,0.5 L3,0.5 L3,1.5 L2.5,1.5 C1.945,1.5 1.505,1.95 1.505,2.5 L1.5,9.5 C1.5,10.05 1.945,10.5 2.5,10.5 L9.5,10.5 C10.05,10.5 10.5,10.05 10.5,9.5 L10.5,2.5 C10.5,1.95 10.05,1.5 9.5,1.5 L9.5,1.5 Z M9.5,9.5 L2.5,9.5 L2.5,4 L9.5,4 L9.5,9.5 L9.5,9.5 Z M3.5,5 L6,5 L6,7.5 L3.5,7.5 L3.5,5 Z" transform="translate(-1,0)"></path></svg><span class="add-to-calendar">Add to Calendar</span></a>'
    );

    $modal.click(function (event) {
      if (
        $(event.target).hasClass('cal-modal') ||
        $(event.target).hasClass('close') ||
        $(event.target).hasClass('content-holder')
      ) {
        $(this).removeClass('active');
      }
    });

    $holder.append('<div class="close">CLOSE</div>');
    $holder.append($content);
    $modal.append($holder);

    return $modal;
  },
  news: function() {
    // on business category change
    $("#news-category").on("change", function () {
      var url = $(this).val(); // get selected value
      if (url) {
          // require a URL
          window.location = url; // redirect
      }
      return false;
    });
  },
  forms: function () {
    $('.form-container form [required="required"]').prev().addClass('required');
    // Send google analytics event on form submission
    $('[data-form-name] form').submit(function () {
      var formWrapper = $(this).closest('[data-form-name]');
      if (window.ga) {
        ga(
          'send',
          'event',
          formWrapper.attr('data-form-name'),
          formWrapper.attr('data-form-page')
        );
      }
    });
    $('.application-form').each(function () {
      if ($(this).attr('data-job-title')) {
        $(this).find('.job-applying-for').val($(this).attr('data-job-title'));
      }
    });
  },

  gdprBanner: function () {
    $('.gdpr-action-modal').each(function () {
      var modal = $(this);
      var key = 'modal-' + modal.data('key');
      var cookie = Cookies.get(key);

      $('.gdprBtn').change(function (e) {
        if ($(this).val() === 'true') {
          $(this)
            .closest('.gdpr-block')
            .removeClass('gdpr-policy-enabled')
            .addClass('gdpr-policy-disabled');
          $(this).attr('value', 'false');
        } else {
          $(this)
            .closest('.gdpr-block')
            .removeClass('gdpr-policy-disabled')
            .addClass('gdpr-policy-enabled');
          $(this).attr('value', 'true');
        }
      });

      if (!cookie) {
        modal.addClass('gdbr-active');
        $('body').addClass('gdbr-modal-active');
      }
      modal.find('.agree-to-all').click(function () {
        $('.gdpr-policy-snippet .gdpr-block')
          .removeClass('gdpr-policy-disabled')
          .addClass('gdpr-policy-enabled');
        if ($('.gdprBtn').val() === 'true') {
          $(this)
            .closest('.gdpr-block')
            .removeClass('gdpr-policy-disabled')
            .addClass('gdpr-policy-enabled');
        }
        $('.gdprBtn').attr('value', 'true');
      });

      modal.find('.save-all').click(function () {
        modal.removeClass('gdbr-active');
        modal.addClass('gdbr-delete');
        $('body').removeClass('gdbr-modal-active');
        Cookies.set(key, 'viewed', { expires: 5 });
        $('.gdpr-policy-snippet').each(function () {
          var modal = $(this);
          var key =
            'snippet-' + modal.data('key').replace(/ /g, '').toLowerCase();
          var snippetID = modal.data('keyid');
          var headerID = key + '-header';
          var bodyID = key + '-body';
          var gdprHeadCode = gdpr_headCodes[snippetID];
          var gdprBodyCode = gdpr_bodyCodes[snippetID];

          $('#' + headerID + '').remove();
          $('#' + bodyID + '').remove();
          if ($(this).find('.gdprBtn').first().val() === 'true') {
            if (typeof gdprHeadCode != 'undefined') {
              $('head').append(
                '<div id="' + headerID + '">' + gdprHeadCode + '</div>'
              );
            }
            if (typeof gdprBodyCode != 'undefined') {
              $('body').append(
                '<div id="' + bodyID + '">' + gdprBodyCode + '</div>'
              );
            }
            Cookies.set(key, 'enabled-x', {
              expires: 365,
            });
          } else {
            $('#' + headerID + '').remove();
            $('#' + bodyID + '').remove();
            Cookies.set(key, 'disabled-x', {
              expires: 365,
            });
          }
        });
      });
    });
    $('.gdpr-policy-snippet').each(function () {
      var modal = $(this);
      var key = 'snippet-' + modal.data('key').replace(/ /g, '').toLowerCase();
      var keyID = '#' + key;
      var headerID = key + '-header';
      var bodyID = key + '-body';
      var snippetID = modal.data('keyid');
      var gdprHeadCode = gdpr_headCodes[snippetID];
      var gdprBodyCode = gdpr_bodyCodes[snippetID];

      if (Cookies.get(key) === 'enabled-x') {
        $('' + keyID + '')
          .find('.gdpr-block')
          .removeClass('gdpr-policy-disabled')
          .addClass('gdpr-policy-enabled');
        $('' + keyID + '')
          .find('.gdprBtn')
          .attr('value', 'true');
        if (typeof gdprHeadCode != 'undefined') {
          $('head').append(
            '<div id="' + headerID + '">' + gdprHeadCode + '</div>'
          );
        }
        if (typeof gdprBodyCode != 'undefined') {
          $('body').append(
            '<div id="' + bodyID + '">' + gdprBodyCode + '</div>'
          );
        }
      } else {
        if (
          $('' + keyID + '')
            .find('.gdpr-block')
            .hasClass('gdpr-policy-enabled')
        ) {
          $('' + keyID + '')
            .find('.gdpr-block')
            .removeClass('gdpr-policy-disabled')
            .addClass('gdpr-policy-enabled');
          $('' + keyID + '')
            .find('.gdprBtn')
            .attr('value', 'true');
          if (typeof gdprHeadCode != 'undefined') {
            $('head').append(
              '<div id="' + headerID + '">' + gdprHeadCode + '</div>'
            );
          }
          if (typeof gdprBodyCode != 'undefined') {
            $('body').append(
              '<div id="' + bodyID + '">' + gdprBodyCode + '</div>'
            );
          }
        } else {
          $('' + keyID + '')
            .find('.gdpr-block')
            .removeClass('gdpr-policy-enabled')
            .addClass('gdpr-policy-disabled');
          $('' + keyID + '')
            .find('.gdprBtn')
            .attr('value', 'false');
          $('#' + headerID + '').remove();
          $('#' + bodyID + '').remove();
        }
      }
    });

    $('.show-privacy-settings').click(function () {
      $('.gdpr-action-modal').addClass('gdbr-active');
      $('.gdpr-action-modal').removeClass('gdbr-delete');
      $('body').addClass('gdbr-modal-active');
      if ($('.gdpr-action-modal').hasClass('show-gdpr-alerts')) {
        $('.gdpr-action-modal').removeClass('show-gdpr-alerts');
      }
    });
  },

  popups: function () {
    $('.action-modal').each(function () {
      var modal = $(this);
      var key = 'modal-' + modal.data('key');
      var cookie = Cookies.get(key);

      if (!cookie) {
        modal.addClass('active');
        $('#wrapper').addClass('action-modal-active');

        var image = modal.find('img');
        var imageHeight = image.outerHeight();
        $('#wrapper').css('paddingTop', imageHeight);
        image.on('load', function () {
          var imageHeight = this.outerHeight();
          $('#wrapper').css('paddingTop', imageHeight);
        });
        $(window).on('resize', function () {
          var imageHeight = image.outerHeight();
          $('#wrapper').css('paddingTop', imageHeight);
        });

        modal.find('.close-action-modal').click(function () {
          modal.addClass('delete');
          modal.removeClass('active');
          $('#wrapper').removeClass('action-modal-active');
          Cookies.set(key, 'viewed', { expires: 5 });
        });
        modal.find('.action-modal-background').click(function () {
          modal.removeClass('active');
        });
      }
    });

    if ($('.cookie-disclaimer').length) {
      // Show the cookie disclaimer
      if (Cookies.get('accepted') != 'accept') {
        setTimeout(function () {
          $('body').addClass('cookie-disclaimer-active');
        }, 1000);
      }

      $('.cookie-button .accept').click(function () {
        $('body').removeClass('cookie-disclaimer-active');
        Cookies.set('accepted', 'accept', {
          expires: 365,
        });
      });
    }
  },

  analytics: function () {
    // Track clicks on external links
    $('body').on('click', 'a[href]', function (e) {
      var domain = String(window.location.host).replace(/^www\./, '');
      var openInNewWindow = $(this).attr('target') == '_blank';
      var url = $(this).attr('href');

      // Find the domain of the link. Works with http, https and protocol-less urls
      var linkAnatomy = url.match(/^(https?:)?\/\/(www\.)?([^\/\s]+)/);
      if (linkAnatomy) {
        var linkDomain = linkAnatomy[3];

        // Check if google analytics is loaded and the url is external
        if (window.ga && domain != linkDomain) {
          ga('send', 'event', 'Navigation', 'Open URL', url);

          // If the link will open in this window we should delay navigation until the event is sent
          if (!openInNewWindow && !e.isDefaultPrevented()) {
            e.preventDefault();

            // Push the navigation onto the queue (will be processed after event is sent)
            ga(function () {
              // Navigate to url
              window.location.href = url;
            });

            return false;
          }
        }
      }
    });
  },
  employment: function () {
    $('.application-form').each(function (i, e) {
      var $form = $(e);
      var jobTitle = $form.data('job-title');
      $form.find('input[id$="-fields-applyingFor"]').val(jobTitle);
    });
  },
  newsletters: function () {
    $('.newsletter-sidebar-desktop').theiaStickySidebar({
      minWidth: 1024,
      additionalMarginTop: 50,
    });

    $('.newsletter-events .events-wrapper').each(function () {
      var articles_wrapper = $(this);
      if ($(articles_wrapper).find('div').length == 0) {
        $('.newsletter-events-header').hide();
      }
    });

    $('.newsletter-archive-wrap .show-newsletter-archive').click(function () {
      $(this).hide();
      $('.newsletter-archive-wrap .newsletter-archive-reach').show();
    });

    //Newsletter section

    $('.newsletter-article-expandable').css({ 'max-height': '320px' });

    $('.newsletter-article')
      .find('.newsletter-article-expand')
      .click(function () {
        var $article = $(this).parent();
        var $expandable = $article.find('.newsletter-article-expandable');
        var $content = $article.find('.newsletter-article-content');

        // toggle class
        $article.toggleClass('is-active');

        // set height to article size
        var height = $content.outerHeight() + 20;
        $expandable.css({ 'max-height': height + 'px' });

        if ($article.hasClass('is-active')) {
          // allow any height after animation done
          setTimeout(function () {
            if ($article.hasClass('is-active')) {
              $expandable.css({ 'max-height': 'none' });
            }
          }, 300);
        } else {
          // if collapsing article set max height
          setTimeout(function () {
            if (!$article.hasClass('is-active')) {
              $expandable.css({ 'max-height': '320px' });
            }
          }, 100);
        }
      });

    $('.newsletter-expand-all').click(function () {
      var $articles = $('.newsletter-article');
      var $expandables = $('.newsletter-article-expandable');

      if ($(this).hasClass('is-expanded')) {
        $articles.removeClass('is-active');
        $expandables.css({ 'max-height': '320px' });
      } else {
        $articles.addClass('is-active');
        $expandables.css({ 'max-height': 'none' });
      }

      $(this).toggleClass('is-expanded');
    });

    $('.newsletter-toggle').click(function () {
      $(this).find('.toggle-nav-newsletter').toggleClass('cross');
      $('.newsletter-sidebar').toggleClass('open-sidenav');
    });

    $('.article-title, .article-sub-title').click(function () {
      var target = $($(this).attr('data-attr'));
      $('html, body').animate(
        {
          scrollTop: target.offset().top - 200,
        },
        800
      );
      var window_width = $(window).width();
      if (window_width < 1023) {
        $('.toggle-nav-newsletter').toggleClass('cross');
        $('.newsletter-sidebar').toggleClass('open-sidenav');
      }
    });

    var window_width = $(window).width();
    if (window_width > 1023) {
      if ($('.toggle-nav-newsletter').hasClass('cross')) {
        $('.toggle-nav-newsletter').removeClass('cross');
      }
      if ($('.newsletter-sidebar').hasClass('open-sidenav')) {
        $('.newsletter-sidebar').removeClass('open-sidenav');
      }
    }
  },

  social: function () {
    // Populate Slider
    function populateSlidersI(posts) {
      $('[data-social]').each(function () {
        var index = 0;
        var block = $('.middle .insta-posts', this);
        var limit = 2;
        var monthAgo = Math.round(Date.now() / 1000) - 2592000;

        posts.forEach(function (post, index) {
          var template = $('#socialtemplate1').html();
          if (post.timestamp > monthAgo) {
            var socialClone = $(template);
            // stop loop
            if (index >= limit) {
              return false;
            }

            var newClone = socialClone.clone(true);
            var text = post.text;

            newClone.find('a.social-link').attr('href', post.link);
            newClone.find('a.social-link').attr('target', '_blank');
            if (post.type == 'VIDEO') {
              var backImage = post.thumbnail;
            } else {
              var backImage = post.image;
            }

            if (post.image) {
              newClone
                .find('a.social-link')
                .css('background-image', 'url(' + backImage + ')');
              newClone.find('.social-icon').addClass('icon-instagram');
            }
            newClone
              .find('.img-c')
              .addClass('is-' + post.channel + '-' + post.type);
            newClone.data('timestamp', post.timestamp);

            block.append(newClone);
          }
        });
      });
    }

    // Populate Slider
    function populateSlidersF(posts) {
      $('[data-social]').each(function () {
        var index = 0;
        var block = $('.middle .fb-posts', this);
        var block2 = $('.right', this);
        var limit = 2;
        var monthAgo = Math.round(Date.now() / 1000) - 2592000;

        posts.forEach(function (post, index) {
          if (index === limit - 1) {
            var template = $('#socialtemplate2').html();
          } else {
            var template = $('#socialtemplate1').html();
          }
          if (post.timestamp > monthAgo) {
            var socialClone = $(template);
            // stop loop
            if (index >= limit) {
              return false;
            }

            var newClone = socialClone.clone(true);
            var text = post.text;

            var len = 120;
            if (text != null) {
              if (text.length > len) {
                text = text.substring(0, len) + '...';
              }
              newClone.find('.text-box').text(text);
            } else {
              newClone.find('.text-box').text(post.link);
            }

            newClone.find('a.social-link').attr('href', post.link);
            newClone.find('a.social-link').attr('target', '_blank');
            var backImage = post.image;

            if (post.image) {
              newClone
                .find('a.social-link')
                .css('background-image', 'url(' + backImage + ')');
              newClone.find('.social-icon').addClass('icon-facebook');
            }
            newClone
              .find('.img-c')
              .addClass('is-' + post.channel + '-' + post.type);
            newClone.data('timestamp', post.timestamp);

            if (index === limit - 1) {
              block2.append(newClone);
            } else {
              block.append(newClone);
            }
          }
        });
      });
    }
    // Facebook
    $.ajax({
      url: '/api/facebook.php',
      dataType: 'json',
      success: function (facebook) {
        var posts = [];
        facebook.posts.data.forEach(function (post) {
          var postData = {};
          postData.type = 'text';
          postData.image = '';
          if (post.attachments != null) {
            var attachment = post.attachments.data[0];
            postData.type = attachment.type;
            if (attachment.subattachments != null) {
              postData.image =
                attachment.subattachments.data[0].media.image.src;
            } else if (attachment.media && attachment.media.image != null) {
              postData.image = attachment.media.image.src;
            }
          }
          postData.link = post.permalink_url;
          postData.text = post.message ? post.message : post.story;
          postData.comments =
            post.comments != null ? post.comments.data.length : 0;
          postData.likes = post.likes != null ? post.likes.data.length : 0;
          postData.timestamp = moment(post.created_time).format('X');
          postData.channel = 'facebook';
          posts.push(postData);
        });
        populateSlidersF(posts);
      },
    });

    //Instagram
    $.ajax({
      url: '/api/instagram.php',
      dataType: 'json',
      success: function (instagram) {
        var posts = [];
        instagram.data.forEach(function (post) {
          var postData = {};
          postData.link = post.permalink;
          postData.image = post.media_url ? post.media_url : '';
          postData.thumbnail = post.thumbnail_url ? post.thumbnail_url : '';
          postData.text = post.caption;
          postData.comments = post.comments_count;
          postData.likes = post.like_count;
          postData.type = post.media_type;
          postData.timestamp = post.unix_timestamp;
          postData.channel = 'instagram';
          posts.push(postData);
        });
        populateSlidersI(posts);
      },
    });
  },

  page_menu_widget: function () {
    $('.page-menu-widget .slider-btn').on('click', function () {
      $(this).toggleClass('open');
      $(this).siblings('.menu-content').slideToggle();
    });
  },

  video_modal: function () {
    $('.has-video .image-box').click(function (e) {
      console.log('click');
      e.preventDefault();
      var modalId = $(this).closest('.item').attr('data-modal-id');
      console.log(modalId);
      var $modal = $('#' + modalId);
      $modal.addClass('is-active');
      digistormWeb.videos.playVideo($modal.find('.video-player'));
    });

    $('.video-modal .modal-background').click(function () {
      var $modal = $(this).closest('.video-modal');
      $modal.removeClass('is-active');
      if (digistormWeb.iOS) {
        digistormWeb.videos.stopVideo($modal.find('.video-player'));
      } else {
        digistormWeb.videos.pauseVideo($modal.find('.video-player'));
      }
    });

    $('.video-modal .close-button').click(function () {
      var $modal = $(this).closest('.video-modal');
      $modal.removeClass('is-active');
      digistormWeb.videos.stopVideo($modal.find('.video-player'));
    });
  },

  read_more: function () {
    var maxLength = 150;
    $('.show-read-more').each(function () {
      var myStr = $(this).text();
      if ($.trim(myStr).length > maxLength) {
        var newStr = myStr.substring(0, maxLength);
        var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
        $(this).empty().html(newStr);
        $(this).append(
          '<p><a href="#" class="read-more-text">Read more</a></p>'
        );
        $(this).append('<span class="more-text">' + removedStr + '</span>');
      }
    });
    $('.read-more-text').click(function (e) {
      e.preventDefault();
      $(this)
        .closest('.show-read-more')
        .find('.more-text')
        .toggleClass('active');
      $(this).toggleClass('active');
    });
  },
};

// Yo!
$(document).ready(function () {
  digistormWeb.init();
  loadGoogleTranslateScript();
});

// Resizing logic
let resizeTimeout;
$(window).resize(function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function () {
    toggleTranslateElements();  // Re-initialize Google Translate on resize
  }, 500);  // 500ms debounce to reduce excessive calls
});

let googleTranslateScriptLoaded = false;

// Function to load Google Translate script dynamically
function loadGoogleTranslateScript() {
  if (googleTranslateScriptLoaded) return;  // Avoid loading multiple times
  window.googleTranslateElementInit = function () {
    toggleTranslateElements();
  };

  const script = document.createElement('script');
  script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
  script.async = true;
  document.head.appendChild(script);
  googleTranslateScriptLoaded = true;
}

// Function to toggle translate elements based on screen size
function toggleTranslateElements() {
  const desktopElement = $('#google_translate_element_desktop');
  const mobileElement = $('#google_translate_element_mobile');

  const initTranslateElement = (elementId) => {
    const targetElement = $(`#${elementId}`);
    if (targetElement.data('translate-initialized')) {
      return;  // Skip initialization if already initialized
    }

    targetElement.html(''); // Clear existing content

    const includedLanguages = targetElement.data('includedLanguages');
    if (!includedLanguages) return; // Ensure languages are specified

    // Initialize Google Translate for the element
    new google.translate.TranslateElement(
      {
        pageLanguage: 'en',
        includedLanguages,
        layout: google.translate.TranslateElement.InlineLayout.VERTICAL,
        autoDisplay: true,
      },
      elementId
    );

    targetElement.data('translate-initialized', true);
  };

  if ($(window).width() >= 1215) {
    // Desktop view
    mobileElement.html('').data('translate-initialized', false);  // Reset mobile
    initTranslateElement('google_translate_element_desktop');
  } else {
    // Mobile view
    desktopElement.html('').data('translate-initialized', false);  // Reset desktop
    initTranslateElement('google_translate_element_mobile');
  }
}


function getParameterByName(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(location.search);
  return results == null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function generateIcs(event) {
  var start = createDate(event.start);
  var end = createDate(event.end);
  console.log(event.timezone);

  var DSToffset =
    Math.floor((0 - start._offset) / 60) + (start.isDST() ? -1 : 1); //other DST offset
  var minutes = (start._offset % 60) + ''; // extra minutes for timezone (eg +0845)
  var sign = '+';
  if (DSToffset < 0) {
    // negative
    sign = '-';
    DSToffset = Math.abs(DSToffset);
  }
  DSToffset += '';
  if (DSToffset.length == 1) {
    DSToffset = '0' + DSToffset;
  }
  if (minutes.length == 1) {
    minutes = '0' + minutes;
  }
  DSToffset = sign + DSToffset + minutes;

  var DSTstart = start.clone().subtract(1, 'day'); // this isn't an accurate timezone start

  // ensure that there are new lines after paragraphs, headings and linebreaks
  var description = String(event.body).replace(
    /(<(\/p|br|\/h[1-6])>)/g,
    '$1\n'
  );

  return (
    'data:text/calendar;charset=utf8,' +
    encodeURIComponent(
      [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID://Digistorm/Calendar',
        'BEGIN:VTIMEZONE',
        'TZID:' + event.timezone,
        'BEGIN:' + (start.isDST() ? 'DAYLIGHT' : 'STANDARD'),
        'DTSTART:' +
          DSTstart.format('YYYYMMDD') +
          'T' +
          DSTstart.format('HHmmss'), // when this timezone started
        'TZOFFSETFROM:' + DSToffset, // was
        'TZOFFSETTO:' + start.format('ZZ'), // now
        'END:' + (start.isDST() ? 'DAYLIGHT' : 'STANDARD'),
        'END:VTIMEZONE',
        'BEGIN:VEVENT',
        'UID:' + event.title + start.unix(), // this is a bad id (what if time or title changes)
        'DTSTAMP:' +
          moment().tz('UTC').format('YYYYMMDD') +
          'T' +
          moment().tz('UTC').format('HHmmss') +
          'Z',
        'DTSTART:' + start.format('YYYYMMDD') + 'T' + start.format('HHmmss'),
        'DTEND:' + end.format('YYYYMMDD') + 'T' + end.format('HHmmss'),
        'SUMMARY:' + event.title,
        'DESCRIPTION:' +
          $('<div>' + description + '</div>')
            .text()
            .replace(/\n/g, '\\n'),
        'END:VEVENT',
        'END:VCALENDAR',
      ].join('\r\n')
    )
  );
}

function createDate(string) {
  var timezone = 'Europe/Berlin';
  if (isNaN(string)) {
    // probably a date string
    return moment.tz(string, timezone);
    console.log(timezone);
  } else if (parseInt(string) < 4000000000) {
    console.log(timezone);
    // probably a unix timestamp (before 2096)
    return moment.unix(string).tz(timezone);
  } else {
    // probably a js timestamp
    return moment.tz(string, timezone);
  }
}

jQuery(document).ready(function ($) {
  $('html').addClass('animated-wowo-control');
  wowo();
  slick();
  tabs();
  accordion();
  selectColor();
  search();
  burger();
  secondMenu();
  stickyMenu();
  bind();
  submenu_headings();
  mobile_news();

  $('.call-to-action .right .item-c:first-child .img-c div').addClass(
    'zoomOut wowo'
  );
  $(window).scroll(function () {
    wowo();
    stickyMenu();
  });
  $(window).on('load', function () {
    wowo();
  });

  function mobile_news() {
    $('.news-events-wrap .show-all-link a').click(function (e) {
      e.preventDefault();

      var $this = $(this).closest('.news-events-wrap').toggleClass('active');
    });
  }

  function submenu_headings() {
    $('.nav-c .sub-menu a').html(function (i, h) {
      return h.replace(/\(([^\)]+)\)/, '<small>$1</small>');
    });
  }

  function bind() {
    $('#back').on('click', function (e) {
      e.preventDefault();
      $('html,body')
        .stop()
        .animate(
          {
            scrollTop: $('body').offset().top,
          },
          500
        );
    });
  }

  function burger() {
    $('.burger').on('click', function () {
      $(this).toggleClass('open');
      $('.nav,.burger-search').toggleClass('open');
    });

    $('.slider-bar .menu-btn').on('click', function () {
      $(this).toggleClass('open');
      $(this).siblings('.menu-content').slideToggle();
    });
  }

  function stickyMenu() {
    var sh = $(window).scrollTop();
    if (sh > 100 && !$('nav').hasClass('smaller')) {
      $('nav').addClass('smaller');
    } else if (sh <= 100 && $('nav').hasClass('smaller')) {
      $('nav').removeClass('smaller');
    }
  }

  function secondMenu() {
    if ($('nav').length > 0) {
      $('nav .has-sub-second').append("<i class='iconfont icon-top'></i>");
      $('nav .has-sub-second').on('click', function (e) {
        if ($(window).width() < 1280) {
          var me = $(this);
          if (!me.hasClass('show')) {
            $(this).children('.sub-menu').slideDown();
            me.addClass('show')
              .siblings('.has-sub-second')
              .removeClass('show')
              .children('.sub-menu')
              .slideUp(250);
          } else {
            me.removeClass('show').children('.sub-menu').slideUp(250);
          }
        } else {
        }
      });
      $('nav .has-sub-second .sub-menu').on('click', function (e) {
        e.stopPropagation();
      });
    }
  }

  function wowo() {
    var wTop = $(window).scrollTop(),
      wHeight = $(window).height(),
      wBottom = wTop + wHeight;
    $('.wowo:not(.animated)').each(function () {
      var me = $(this),
        meTop = me.offset().top,
        meHeight = me.innerHeight(),
        meBottom = meTop + meHeight,
        limitTop = wTop - meHeight,
        limitBottom = wBottom + meHeight;
      if (meTop > limitTop && meBottom < limitBottom) {
        me.addClass('animated');
        setTimeout(function () {
          me.removeClass('animated wowo');
        }, 1500);
      }
    });
  }

  function search() {
    if ($('nav #search-button').length > 0) {
      $('nav #search-button').click(function (e) {
        e.preventDefault();
        ot = $(window).scrollTop();
        $('#search-box').stop().fadeIn(300).addClass('show-it');
        sTime = setTimeout(function () {
          $('body').stop().addClass('modal-open-search');
          $('#search-box').find('.input').stop().focus();
        }, 900);
      });
      $('#search-close').click(function () {
        clearTimeout(sTime);
        $('.modal-open-search').removeClass('modal-open-search');
        $('html,body').stop().animate(
          {
            scrollTop: ot,
          },
          1
        );
        $('#search-box').stop().fadeOut(300).removeClass('show-it');
        $('#search-box').find('.input').stop().blur();
      });
    }
  }

  function tabs() {
    if ($('.tabs-wrap').length > 0) {
      $('.tabs-wrap .tabs ul li').each(function () {
        if ($(this).hasClass('is-active')) {
          $(this)
            .parents('.tabs-wrap')
            .find('.text-box')
            .eq($(this).index())
            .show();
        }
      });
      $('.tabs-wrap .tabs ul li').click(function (e) {
        e.preventDefault();
        var that = $(this),
          index = that.index(),
          parents = that.parents('.tabs-wrap'),
          content = parents.find('.text-box').eq(index);
        if (!that.hasClass('is-active')) {
          that
            .addClass('is-active')
            .siblings('.is-active')
            .removeClass('is-active');
          content.stop().fadeIn(1000).siblings().css('display', 'none');
        }
      });
    }

    if ($('.call-to-action').length > 0) {
      $('.call-to-action .text-c ul li').each(function () {
        if ($(this).hasClass('active')) {
          $(this)
            .parents('.text-c')
            .siblings('.right')
            .find('.item-c')
            .eq($(this).index())
            .show();
        }
      });
      $('.call-to-action .text-c ul li').click(function (e) {
        e.preventDefault();
        var that = $(this),
          index = that.index(),
          parents = that.parents('.text-c').siblings('.right'),
          content = parents.find('.item-c').eq(index);
        if (!that.hasClass('active')) {
          that.addClass('active').siblings('.active').removeClass('active');
          content.stop().fadeIn(300).siblings().css('display', 'none');
        }
      });
    }
  }

  function accordion() {
    if ($('.accordion-wrap').length > 0) {
      $('.accordion-wrap .item').each(function () {
        if ($(this).hasClass('is-active')) {
          $(this).find('.item-content').show(250);
        }
      });
      $('.accordion-wrap .item-title').click(function (e) {
        e.preventDefault();
        var that = $(this),
          parent = that.parents('.item');
        if (!parent.hasClass('is-active')) {
          that.next().stop().slideDown(250);
          parent
            .addClass('is-active')
            .siblings('')
            .removeClass('is-active')
            .find('.item-content')
            .slideUp(250);
        } else {
          parent.removeClass('is-active').find('.item-content').slideUp(250);
        }
      });
    }
  }

  function selectColor() {
    if ($('.form-wrap select:not([multiple])').length > 0) {
      $('.form-wrap select:not([multiple])')
        .parents('.control')
        .append("<span class='iconfont icon-bottom'></span>");
      var unSelected = '#0A193F';
      var selected = '#0A193F';
      $(function () {
        $('.form-wrap select:not([multiple])').css('color', unSelected);
        $('.form-wrap select:not([multiple])').change(function () {
          var selItem = $(this).val();
          if (selItem == $(this).find('option:first').val()) {
            $(this).css('color', unSelected);
          } else {
            $(this).css('color', selected);
          }
        });
      });
    }
  }

  function slick() {
    // var media_slider = $(".home-slider-wrap .slider");
    // if (media_slider.length > 0) {
    //   media_slider.slick({
    //     infinite: true,
    //     arrows: true,
    //     pauseOnHover: false,
    //     pauseOnDotsHover: false,
    //     accessibility: false,
    //     dots: false,
    //     fade: true,
    //     speed: 800,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     autoplay: true,
    //     autoplaySpeed: 5200,
    //     prevArrow: '<button type="button" class="slick-prev"><span class="icon-arrow-left"></span></button>',
    //     nextArrow: '<button type="button" class="slick-next"><span class="icon-arrow-right"></span></button>',
    //   });
    // }
    // media_slider.find(".item").addClass("move");
    // media_slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    //   media_slider.find(".item").removeClass("move");
    //   setTimeout(function () {
    //     media_slider.find(".item").addClass("move");
    //   }, 400);
    // });
    // var home_banner = $(".global-banners.home-banners .banners");
    // if (home_banner.length > 0) {
    // 	home_banner.slick({
    // 		infinite: true,
    // 		arrows: false,
    // 		pauseOnHover: false,
    // 		pauseOnDotsHover: false,
    // 		accessibility: false,
    // 		dots: false,
    // 		fade: true,
    // 		speed: 800,
    // 		slidesToShow: 1,
    // 		slidesToScroll: 1,
    // 		autoplay: true,
    // 		autoplaySpeed: 5200,
    // 	});
    // 	home_banner.find(".banner").addClass("move");
    // 	home_banner.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    // 		home_banner.find(".banner").removeClass("move");
    // 		setTimeout(function () {
    // 			home_banner.find(".banner").addClass("move");
    // 		}, 400);
    // 	});
    // }

    $('.slider-wrap').each(function () {
      var $slickElement = $(this).find('.slider');
      $slickElement.slick({
        infinite: true,
        arrows: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        accessibility: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
      });
    });

    $('.testimonials-wrap.display-carousel').each(function () {
      var $slickElement = $(this).find('.tile-wrapper');
      var $dotsWrapper = $(this).find('.slick-dots-wrapper');

      var activeClass = 'slick-active',
          ariaAttribute = 'aria-hidden';
          $slickElement
      .on( 'init', function() {
        $dotsWrapper.find( 'li:first-of-type' ).addClass( activeClass ).attr( ariaAttribute, false );
      } )
      .on( 'afterChange', function( event, slick, currentSlide ) {

          $( 'li', $dotsWrapper ).removeClass( activeClass ).attr( ariaAttribute, true );
          $dotsWrapper.each( function() {
              $( 'li', $( this ) ).eq( currentSlide ).addClass( activeClass ).attr( ariaAttribute, false );
          } );
      } );

      $slickElement.slick({
        arrows: false,
        dots: true,
        appendDots: $dotsWrapper,
        infinite: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    });

  }
});
